
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/elasticsearch",
      function () {
        return require("private-next-pages/destinations/elasticsearch.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/elasticsearch"])
      });
    }
  